export { default } from './restaurantCardImage';
export type { RestaurantCardImageProps } from './restaurantCardImage';
